var superTiny = "4px";
var tiny = "8px";
var small = "16px";
var base = "32px";
var medium = "40px";
var large = "64px";
export default {
    superTiny: superTiny,
    tiny: tiny,
    small: small,
    base: base,
    medium: medium,
    large: large
};
